// import Navbar from "./components/Navbar/Navbar";
// import Footer from "./components/Footer/Footer";

import FAQ from "./faq/faq";
import Footer from "./footer/footer";
import Hero from "./Hero/hero";
import HowItWorks from "./howworks/howitworks";
import Navication from "./Navbar/navbar";
import WhyChoose from "./whychoose/whytochoose";


function Home() {

    return (

        <>

            {/* <ScrollToTop /> */}

            <Navication />

            <Hero />

            <WhyChoose />

            <HowItWorks />

            <FAQ />

            <Footer />

        </>

    );

}

export default Home;